import classNames from 'classnames'
import Link from 'next/link'
import { t } from '../../../utils'
import { useAuth } from '../../../utils/auth'
import styles from './_tryItBlock.module.scss'

function TryItBlock() {
  const { currentUser } = useAuth()
  const isRegularPlan = currentUser && !currentUser.onFreePlan
  if (isRegularPlan) return <></>
  return (
    <div className={classNames(styles.storeTryIt, 'section')}>
      <div className="container">
        <div
          className={classNames(
            'columns is-centered is-mobile is-multiline',
            styles.subscribeBlock
          )}
        >
          <div className="column is-12-mobile is-7-tablet content">
            <h3>Ready to give it a try?</h3>
            <p>
              Subscribe today and enjoy discounts we’re offering to our members
              exclusively.
            </p>
          </div>
          <div className="column is-12-mobile is-narrow-tablet ">
            <Link
              href="/store/pre_sign_up"
              prefetch={false}
              className="button is-primary is-large is-inline-block is-rectangular"
            >
              {t('subscribe now')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TryItBlock
